/*eslint-disable */
define(function (require) {
    var momentLib = require('moment');
    var PageConfig = require('common/page-config');
    var DateFormatter = require('common/formatter/date-formatter');
    var TimeFormatter = require('common/formatter/time-formatter');


    var DataTimeFormatter = function () {
        var moment = momentLib;
        var date = DateFormatter;
        var time = TimeFormatter;
        var settings = PageConfig.hasOwnProperty('locale') ? PageConfig.locale : {timeFormat: 'h:mm a'};

        var initialize = function () {
            // add translations
            if (settings && settings.hasOwnProperty('locale')) {
                addTranslations();
            }
        };

        var addTranslations = function () {
            moment.locale(settings.locale);
        };

        var getDate = function (format, date) {
            return moment(date).format(settings.dateTimeFormats[format].javascriptMomentFormat);
        };

        var getDatesDiff = function (startDate, endDate, units) {
            var startOfToday = moment(startDate).startOf('day');
            var startOfDate = moment(endDate).startOf('day');

            return startOfDate.diff(startOfToday, units);
        };

        var getTime = function (type, format, time) {
            var timeObj;

            switch (type) {
                case 'fromMidnight':
                    timeObj = fromMinutesPastMidnight(time);
                    break;
                default:
                    timeObj = fromHoursMinutes(time);
                    break;
            };

            // Set the time
            var formattedTime = moment().hour(timeObj.hour).minute(timeObj.minute);
            // return time with locale format
            return formattedTime.format(settings.dateTimeFormats[format].javascriptMomentFormat);
        };

        var fromHoursMinutes = function (time) {
            return {
                hour: time / 100,
                minute: time % 100
            };
        };

        var fromMinutesPastMidnight = function (time) {
            return {
                hour: time / 60,
                minute: time % 60
            };
        };


        return {
            initialize: initialize,
            getDate: getDate,
            getTime: getTime,
            getDatesDiff: getDatesDiff
        };
    };

    // initialize wrapper
    var formatter = new DataTimeFormatter();
    formatter.initialize();
    // return object
    return formatter;
});
